export enum PowderApplication {
	Internal = 0,
	ExternalIndustry = 10,
	ExternalFassade = 20,
}
